import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import FormFields from "../../atoms/FormFields";
import Buttons from "../../atoms/Buttons";
import CustomDropdownMenu from "../../atoms/CustomDropdownMenu";
import "./choosingFlexiAccessRetirementPopup.scss";
import { Link } from "react-router-dom";

const ChoosingFlexiAccessRetirementModel = (props) => {
  const [amount, setAmount] = useState(
    props?.flexiAcessCurrentIncome
      ? `£${props.flexiAcessCurrentIncome.replace("£", "").trim()}`
      : "£" + 0 //eslint-disable-line
  );
  const [period, setPeriod] = useState(
    props?.flexiAccessDuration
      ? props?.flexiAccessDuration === "Annual"
        ? "Annually"
        : props?.flexiAccessDuration === "HalfYearly"
          ? "Half yearly"
          : props?.flexiAccessDuration === "Quarterly"
            ? "Quarterly"
            : "Monthly"
      : "Monthly", //eslint-disable-line
  );
  const [isError, setIsError] = useState(false);

  const periodOptions = [
    {
      option: "Monthly",
      value: "Monthly",
    },
    {
      option: "Quarterly",
      value: "Quarterly",
    },
    {
      option: "Half yearly",
      value: "Half yearly",
    },
    {
      option: "Annually",
      value: "Annually",
    },
  ];

  useEffect(() => {
    if (props.flexiAccessCurrentIncome !== undefined) {
      const formattedAmount = `£${props.flexiAccessCurrentIncome
        .replace("£", "")
        .trim()}`;
      setAmount(formattedAmount);
    }
    if (props.flexiAccessDuration !== undefined) {
      setPeriod(
        props?.flexiAccessDuration
          ? props?.flexiAccessDuration === "Annual"
            ? "Annually"
            : props?.flexiAccessDuration === "HalfYearly"
              ? "Half yearly"
              : props?.flexiAccessDuration === "Quarterly"
                ? "Quarterly"
                : "Monthly"
          : "Monthly",
      ); //eslint-disable-line;
    }
  }, [props.flexiAccessCurrentIncome, props.flexiAccessDuration]);

  const changePeriodValue = (value) => {
    setPeriod(value);
  };

  const amountChange = (e) => {
    let inputValue = e.target.value.replace("£", "").trim();

    // Remove leading zeros unless it's "0" or "0.xx"
    if (/^0[0-9]+/.test(inputValue)) {
      inputValue = inputValue.replace(/^0+/, "");
    }

    const isValidFormat = /^\d*\.?\d{0,2}$/.test(inputValue);
    if (!isValidFormat) return;

    if (Number(inputValue) <= props.flexiAccessTotalValue) {
      setAmount("£" + inputValue);
      setIsError(false);
    } else {
      setIsError(true);
    }
  };

  const handleChooseFlexiAccessIncome = () => {
    const numericAmount = parseFloat(amount.replace("£", "").trim());
    if (numericAmount > 0) {
      props.handleFlexiAccessContinue(amount, period);
    } else {
      setIsError(true);
    }
  };

  return (
    <div className="parent-choose-flexi-access">
      <Row className="mb-3">
        <Col>
          <div className="cfa-small-close">
            <Link to="">
              <Icons
                iconname="close"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row className="cfa-title mb-3">
        <div>
          <Icons iconname="chevron-left" variant="icon-twenty-eight-px" />
          <span>{props.modalTitle}</span>
        </div>
      </Row>
      <Row className="cfa-sub-title mb-3">
        <Col>
          <div>
            Your current investments will be carried across into flexi-access
            (the same fund charges apply). Any Growth Plan 3 amount will
            initially be invested in the Target Date Fund associated with your
            target retirement age. You can update these at any time once your
            application has been processed. With flexi-access, you can decide
            how much income you’d like to take and how often. You can set this
            now, or online later.
          </div>
        </Col>
      </Row>
      <Row className="cfa-sub-title mb-3">
        <Col>
          <div>
            With flexi-access, you can decide how much income you’d like to take
            and how often. You can set this now, or online later.
          </div>
        </Col>
      </Row>
      <Row className="cfa-review mb-3">
        <Col>
          <div>I would like to receive:</div>
        </Col>
      </Row>
      <Row className="mb-5">
        <Col xl={5} lg={5} md={5}>
          <FormFields
            value={amount}
            variant={isError ? "form-field-plain-error" : "form-field-plain"}
            plainTextField={true}
            changeHandler={amountChange}
          />
        </Col>
        <Col xl={5} lg={5} md={5}>
          <CustomDropdownMenu
            dropDownData={periodOptions}
            selectedItem={changePeriodValue}
            defaultValue={period}
          />
        </Col>
      </Row>
      <Row className="cfa-sub-title mb-4">
        <Col>
          <div className="imp-text">
            Important - regular income payments are all paid together, so if you
            also have managed income or future annuity income please ensure that
            you select <strong>monthly</strong> above.
          </div>
        </Col>
      </Row>
      <Row className="cfa-sub-title mb-4">
        <Col>
          <div className="italic-text">
            Payments are made on the 5th of the month. OR Payments will be on
            the anniversary of the initial payment. For example, if the first
            payment is 5th March and you select twice a year, the next payment
            would be on 5th September.
          </div>
        </Col>
      </Row>
      <Row className="cfa-sub-title mb-4">
        <Col>
          <div>
            Your payments will continue until further notice, or until your
            drawdown runs out, whichever is sooner.
          </div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xl={12} lg={12} md={12}>
          <div className="cfa-button">
            {props.isCancel ? (
              <div className="cfa-cancel-button">
                <Buttons
                  name="Cancel"
                  className="secondary"
                  variantname="icon-sixteen-px"
                  handleClick={props.handleCloseButton}
                ></Buttons>
              </div>
            ) : (
              <div className="cfa-cancel-button">
                <Buttons
                  name="Proceed without income"
                  className="secondary"
                  variantname="icon-sixteen-px"
                  handleClick={() => props.handleFlexiAccessContinue(0, null)}
                ></Buttons>
              </div>
            )}
            <div>
              <Buttons
                name="Continue"
                className="primary"
                variantname="icon-sixteen-px"
                handleClick={handleChooseFlexiAccessIncome}
                disabled={
                  parseFloat(String(amount ?? 0).replace("£", "")) > 0
                    ? false
                    : true
                }
              ></Buttons>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ChoosingFlexiAccessRetirementModel;
